/**
 * Keeps the header entries chip in step with the cart. Listens for the
 * theme's cart update event and re-renders itself from the section API.
 */
class FFHeaderEntries extends HTMLElement {
  #unsubscribe = null;
  #controller = null;

  connectedCallback() {
    this.addEventListener('click', (event) => this.#openDrawer(event));
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.#unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
  }

  /* With the cart drawer on the page the chip opens it; without it the link still goes to /cart. */
  #openDrawer(event) {
    const chip = event.target.closest('.ff-header-chip');
    const drawer = document.querySelector('cart-drawer');
    if (!chip || !drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(chip);
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
    this.#controller?.abort();
  }

  async refresh() {
    this.#controller?.abort();
    this.#controller = new AbortController();

    const url = new URL(this.dataset.sectionUrl || '/', window.location.origin);
    url.searchParams.set('sections', 'ff-header-entries');

    try {
      const response = await fetch(url, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const sections = await response.json();
      const html = new DOMParser().parseFromString(sections['ff-header-entries'], 'text/html');
      const next = html.querySelector('ff-header-entries');
      if (!next) return;

      const changed = next.dataset.total !== this.dataset.total;
      this.dataset.total = next.dataset.total;
      this.innerHTML = next.innerHTML;
      if (changed) this.#pulse();
    } catch (error) {
      if (error.name !== 'AbortError') console.error('Header entries refresh failed:', error);
    }
  }

  #pulse() {
    const chip = this.querySelector('.ff-header-chip');
    if (!chip) return;
    chip.classList.remove('ff-header-chip--bump');
    void chip.offsetWidth;
    chip.classList.add('ff-header-chip--bump');
  }
}

if (!customElements.get('ff-header-entries')) customElements.define('ff-header-entries', FFHeaderEntries);
